import React, {Component} from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Grid, Typography, Fade, makeStyles} from '@material-ui/core'
import { grey} from '@material-ui/core/colors'

import NavigationTitle from '../../Navigation/NavigationTitle'
import CustomSnackbar from '../../Snackbars/CustomSnackbar'
import SimpleLoader from '../../Loaders/SimpleLoader'
import SmallNavigation2 from '../../Navigation/SmallNavigation2';

const useStyles = makeStyles(theme => ({
  root:{
    padding:'32px',
    [theme.breakpoints.down('sm')]: {
      padding:'16px',
    },
  },
  loader:{
    color:grey[700],
    fontWeight:'400'
  },
  loaderContainer:{
    padding:'40px'
  }
}))

const BasicView = props => {

  const classes = useStyles()
    const {history, selected, onChange, content, onReturn, returnBtn, isloading} = props;

    let menuContent = null
    if(content.menu){
      menuContent = (
        <Grid item xs={12}>
          <Grid container justify='flex-start'>
            <Grid item>
              <SmallNavigation2 
                selected={selected}
                options={content.menu}
                onChange={onChange}
              />
            </Grid>
          </Grid>
        </Grid>
      )
    }
    
    let contentData = null

    if(isloading){
      contentData = (
        <div className={classes.loaderContainer}>
          <Grid container alignItems='center' direction='column' spacing={1}>
            <Grid item>
              <SimpleLoader />
            </Grid>
            <Grid item>
              <Typography variant='body2' className={classes.loader}>Loading...</Typography>
            </Grid>
          </Grid>
        </div>
        
      )
    }else{
      contentData = (
        <Fade in timeout={1000}>
          <div>
            {props.children}
          </div>
        </Fade>
        
      )
    }
    
    return(
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <NavigationTitle 
              history={history}
              title={content.title}
              navigation={content.navigation}
              returnBtn={returnBtn}
              onReturn={onReturn}
            />
          </Grid>        
          <Grid item xs={12}>
            <Grid container spacing={3}>
              {menuContent}
              <Grid item xs={12}>
                {contentData}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    )
}

export default BasicView